
import { CrudField } from "../../CrudField";

export default {
  props: {
    field: {
      type: CrudField,
      required: true
    }
  },
  computed: {
    emailLink() {
      return "mailto:" + this.field.value;
    },
    noneText() {
      return this.$config.readonlyNoneDisplay;
    }
  }
};
